import { render, staticRenderFns } from "./dispensation3.vue?vue&type=template&id=0b70840b&scoped=true"
import script from "./dispensation3.vue?vue&type=script&lang=js"
export * from "./dispensation3.vue?vue&type=script&lang=js"
import style0 from "./dispensation3.vue?vue&type=style&index=0&id=0b70840b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70840b",
  null
  
)

export default component.exports